import { Command } from 'commands/Commands';

export class ChangeMemberPhoneVisibility extends Command {
  type: string = 'Member.ChangePhoneVisibility';
  priority = 100;
}
